(function ($) {
    'use strict';

    $(function () {
        function type(target, targetChildren) {
            var afterHeader = $(target);
            var siteDescription = $(targetChildren);
            var siteDescriptionText = siteDescription.text();
            var siteDescriptionLength = siteDescriptionText.length;
            siteDescription.empty();
            afterHeader.css('opacity', '1');
            if (siteDescriptionLength > 27) {
                var firstPart = siteDescriptionText.substring(0, 27);
                var secondPart = siteDescriptionText.substring(27, siteDescriptionText.length);
                siteDescription.typeIt({
                    speed: 85,
                    autoStart: false,
                }).tiType(firstPart).tiPause(2000).tiSettings({speed: 60}).tiBreak().tiType(secondPart).tiSettings({
                    callback: function () {
                        $('span.ti-cursor').remove();
                    }
                });
            } else {
                siteDescription.typeIt({
                    strings:[siteDescriptionText],
                    callback: function () {
                        $('span.ti-cursor').remove();
                    }
                });
            }
        }

        var coverHeader = $('.cover-header');
        if (0 !== coverHeader.length) {
            type('.cover-header', '.cover-header span, .cover-header h1.work-title');

        } else {
            type('.after-header', '.after-header span, .after-header h2, .single .after-header p, .archive .after-header p');
        }
    });

})(jQuery);